import React from 'react';
import { Crown } from 'lucide-react';
import { useTranslation } from '../../../../contexts/LanguageContext';

const MobilePremiumUpgradeBanner = ({ 
  isPremium, 
  spacesCount, 
  maxFreeSpaces,
  onUpgrade 
}) => {
  const { t } = useTranslation();
  
  if (isPremium) return null;

  return (
    <div className="mt-8 p-4 bg-gradient-to-r from-blue-50 to-amber-50 rounded-xl border border-gray-200">
      <div className="flex flex-col items-center text-center">
        <div className="flex items-center justify-center mb-3">
          <Crown className="h-6 w-6 text-amber-500 mr-2" />
          <span className="text-base font-medium text-gray-900">
            {t('sharesubs.premiumUpgradeBanner.title', 'EasySubs Premium Features')}
          </span>
        </div>
        
        <p className="text-gray-600 text-sm mb-4 max-w-md">
          {spacesCount >= maxFreeSpaces
            ? t('sharesubs.premiumUpgradeBanner.reachedLimit', `You've reached the limit of ${maxFreeSpaces} free sharing spaces. Upgrade to create unlimited spaces.`)
            : t('sharesubs.premiumUpgradeBanner.unlockFeatures', 'Unlock unlimited sharing spaces, track more merchants, and get premium analytics.')
          }
        </p>
        
        <button 
          onClick={onUpgrade}
          className="w-full py-2.5 bg-gradient-to-r from-[#253985] to-amber-500 text-white rounded-lg text-sm font-semibold hover:shadow-lg hover:shadow-amber-500/30 transition-all duration-300 hover:scale-[1.02] active:scale-[0.98]"
        >
          {t('sharesubs.premiumUpgradeBanner.upgradeNow', 'Upgrade Now')}
        </button>
      </div>
    </div>
  );
};

export default MobilePremiumUpgradeBanner;